import { environment } from '../../environments/environment';
import { Observable, of, throwError } from 'rxjs';
import * as _ from 'lodash';
import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IUserInfo ,AuthService} from '../shared/core/index';
import { ReportGenerate } from './reports-generate.model';
import { IReportItem } from './reports-Item.model';
import { ReportBuilder } from './reports-builder.model';
import { catchError, map, retry, tap } from 'rxjs/operators';
import { ILookup } from '../shared/lookup';
import { HttpService } from '../shared/core/http.service';


@Injectable()
export class ReportsService {

    private _userInfo: IUserInfo;
    private _reportsUrl = new URL('reports', environment.apiUrl).toString();
    
    constructor(private _http: HttpClient, private _httpService: HttpService, private authService: AuthService, private ngZone: NgZone) {
        this.authService.subscribeToLoginService().subscribe(r => { this._userInfo = r });
    }
    downloadReport(url: string): Observable<Blob> {
        return new Observable<Blob>(subscriber => {
            return this._http.get(url, { responseType: 'blob' }).pipe(
                map((res) => new Blob([res], { type: 'application/pdf' })),
                tap(data => data),
                catchError(this.handleError)
            ).subscribe({
                next: (value) => this.ngZone.run(() => subscriber.next(value)),
                error: (err) => this.ngZone.run(() => subscriber.error(err)),
                complete: () => this.ngZone.run(() => subscriber.complete())
            });
        });
    }

    generateReports(searchData: ReportBuilder): Observable<string> {
        searchData.requestType ='GenerateReports';
        if (searchData.searchByValue == null) {
            searchData.searchByValue = '';
        }
        if (!searchData.searchByValue) {
            searchData.searchBy = searchData.searchBy || 'All';
        }
        console.log('calling getReport() from ' + this._reportsUrl);
        var body = JSON.stringify(searchData);
        console.log(body);
        if(body.indexOf("<") !== -1 || body.indexOf(">") !== -1){
            console.log('AntiXssMiddleware angled brackets ("<", ">") in your input(s).');
            return throwError(() => "AntiXssMiddleware");
        }
        return this._httpService.httpPost(this._reportsUrl, body, null, null, 'text').pipe(
            map((response) => response || ''),
            tap(data => data),
            catchError(this.handleError)
        );
    }

    getTags(searchData: ReportBuilder): Observable<ILookup[]> {
        searchData.requestType ='GetTags';
        console.log('calling getReport() from ' + this._reportsUrl);
        var body = JSON.stringify(searchData);
        return this._httpService.httpPost(this._reportsUrl, body).pipe(
        map((response: any) => response),
            tap(data => data),
            catchError(this.handleError)
        );
    }
    
    getReportsList(requestData: ReportBuilder ):Observable<ReportBuilder> {
        console.log('calling getReportsList() from ' + this._reportsUrl);
        requestData.requestType ='GetReportsList';
        var body = JSON.stringify(requestData);
        return this._httpService.httpPost(this._reportsUrl, body).pipe(
        map((response) => {
            return this.mapListSearchData(response);
        }),
            tap(data => data),
            catchError(this.handleError)
        );
    }

    deleteReport(id: string): Observable<boolean> {

        if (!id) {
            console.error('cannot delete an empty report, try passing the id...');
            return of(false);
        }

        let url = new URL(id, this._reportsUrl + '/').toString();
        console.log('deleteReport() at ' + url + ' for report: ' + JSON.stringify(id));

        return this._httpService.httpDelete(url).pipe(
            map(() => {
                console.log('deleteReport');
                return true;
            }),
            catchError((error: any) => {
                // Empty 200/204 body used to fail JSON parsing; treat as success.
                if (error && (error.status === 200 || error.status === 204)) {
                    return of(true);
                }
                return this.handleError(error);
            })
        );

    }

    getReportsItem(requestData: ReportBuilder ):Observable<IReportItem> {
        console.log('calling getReportsItem() from ' + this._reportsUrl);
        requestData.requestType ='GetReport';
        var body = JSON.stringify(requestData);
        return this._httpService.httpPost(this._reportsUrl, body).pipe(
        map((response: any) => {
            return this.toReportItem(response);
        }),
            tap(data => data),
            catchError(this.handleError)
        );
    }
    mapListSearchData(response: any): ReportBuilder {
        var ret = this.toListSearchData(response);
        return ret;
    }
    toListSearchData(data: any): ReportBuilder {
        if (data) {
            console.log(data);
            let listSearchData: ReportBuilder = new ReportBuilder();
            listSearchData.pageStartIndex = data.PageStartIndex != null ? data.PageStartIndex : data.pageStartIndex;
            listSearchData.pageSize = data.PageSize != null ? data.PageSize : data.pageSize;
            listSearchData.totalNumberOfRecords = data.TotalNumberOfRecords != null
                ? data.TotalNumberOfRecords
                : data.totalNumberOfRecords;
            listSearchData.reportPrivilegedNotes=data.ReportPrivilegedNotes;
            listSearchData.reports = [];
            if (data.ResultSet) {
                data.ResultSet.forEach(element => {
                    listSearchData.reports.push(this.toReportItem(element));
                });
            }
            return listSearchData;
        }
    }
    toReportItem(data: any):IReportItem{
        let retValue: IReportItem = new IReportItem();
        retValue.createdDate = data.CreatedDate;
        retValue.createdBy = data.CreatedBy;
        retValue.errorMessage = data.ErrorMessage;
        retValue.reportName = data.ReportName;
        retValue.reportStatus = data.ReportStatus;
        retValue.reportUrl = data.ReportUrl;
        retValue.reportId = data.ReportId;
        retValue.status = data.Status;
        retValue.sortedBy = data.SortedBy;
        retValue.searchBy = data.SearchBy;
        retValue.searchByValue = data.SearchByValue;
        retValue.sortDirection = data.SortDirection;
        retValue.projectId = data.ProjectId;
        retValue.restrictionType = data.RestrictionType;
        retValue.customHeader=data.customHeader;
        retValue.isCustomHeaderSelected=data.customHeader;
        retValue.selectedIDs=data.SelectedIDs;
        retValue.projectName=data.ProjectName;
        retValue.status=data.Status;
        retValue.fileFormat=data.FileFormat;
        return retValue;
    }
    getFilters(): any {
        return {};
    }

    private handleError(error: any) {
        // in a real world app, we may send the server to some remote logging infrastructure
        // instead of just logging it to the console
        console.error('reportService.handleError(...() >>> There has been an error while calling api, error:', error);

        return throwError(() => error || 'Server error');
    }
}
